import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'PRÉPARER CHAQUE COURS VOUS DEMANDE ÉNORMÉMENT DE TEMPS',
  description: "Chaque semaine, vous cherchez des exercices, préparez vos séances, construisez des progressions, imaginez des chorégraphies et adaptez vos activités aux différents niveaux. Au final, préparer vos cours prend parfois presque autant de temps que les enseigner."
}, {
  emoji: '⚠️',
  title: 'VOUS NE SAVEZ PAS TOUJOURS QUOI PROPOSER ENSUITE',
  description: "Quel exercice choisir aujourd'hui ? Comment faire progresser mes élèves ? Comment adapter la même séance à plusieurs niveaux ? Construire des cours variés, cohérents et progressifs semaine après semaine devient un véritable défi."
}, {
  emoji: '📚',
  title: 'VOS RESSOURCES SONT DISPERSÉES PARTOUT',
  description: "Exercices. Échauffements. Chorégraphies. Progressions. Fiches. Idées de cours. Tout existe… mais entre vos livres, PDF, formations, vidéos et dossiers, vous perdez encore du temps à chercher ce dont vous avez besoin."
}, {
  emoji: '😩',
  title: "VOUS PASSEZ TROP DE TEMPS À PRÉPARER AU LIEU D'ENSEIGNER",
  description: "Entre la planification, les exercices, les adaptations et l'organisation de l'année, il reste moins de temps pour ce qui compte vraiment : enseigner, accompagner vos élèves et transmettre votre passion pour la danse."
}];
export function PainSection() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-cream" data-id="element-117" data-mp="38wsybnuon610">
      <h2 className="text-2xl sm:text-3xl font-heading font-bold text-center text-brand-title mb-2 uppercase leading-tight" data-id="element-118" data-mp="33y7wjjzs8eag">
        VOUS VOUS RECONNAISSEZ ?
      </h2>

      <p className="text-sm sm:text-base text-brand-text font-medium text-center mb-6 leading-relaxed max-w-xl mx-auto" data-id="element-119" data-mp="3dvw1t3v0l46v">
        Vous adorez enseigner la danse. Mais préparer chaque cours finit par
        vous prendre une grande partie de votre semaine.
        <br className="hidden sm:block" data-id="element-120" data-mp="2l6fayan1lvcr" />
        <span className="text-brand-rose font-bold mt-2 block" data-id="element-121" data-mp="p426xijdm6hx">
          Si vous enseignez dans une école, une association, un studio ou en
          cours particuliers, vous avez probablement déjà vécu ceci :
        </span>
      </p>

      <div className="flex flex-col gap-3" data-id="element-122" data-mp="yuohgyc8k6tr">
        {pains.map((pain, i) => <div key={i} className="bg-white p-4 rounded-lg border-l-4 border-brand-rose shadow-sm flex gap-4 items-start" data-id="element-123" data-mp="12vqklq99x310" data-mpi={i}>
            <div className="text-2xl leading-none shrink-0 mt-0.5" data-id="element-124" data-mp="670wvjaytg74">
              {pain.emoji}
            </div>
            <div data-id="element-125" data-mp="f5mdva0sgn5s">
              <h3 className="text-base font-bold text-brand-title mb-1 uppercase tracking-tight" data-id="element-126" data-mp="f54morszgz4q">
                {pain.title}
              </h3>
              <p className="text-brand-text text-sm font-medium leading-relaxed" data-id="element-127" data-mp="k6acohv9e8ak">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}